export default __webpack_public_path__ + "static/media/october-2020.2f20d980.csv";